import AdminAddUserPage from './AdminAddUserPage'
export default AdminAddUserPage;